export class OvertimeSearchRequest {
    departmentId: number;
    fullName: string;
    overtimeEndDate: string;
    overtimeStartDate: string;
    overtimeTypeId: number;
    branchCode : string;
    projectCode: string;
    tenantCode: string;
    pageNumber: number;
    size: number;
    sortColumn: string;
    sortDirection: number;    
    status: number;   

    // add constructor
    constructor(pageNumber,size,sortColumn,sortDirection) {
        this.pageNumber = pageNumber;
        this.size = size;
        this.sortColumn = sortColumn;
        this.sortDirection = sortDirection;
    }
}
